import { render, staticRenderFns } from "./PlanBoardButton.vue?vue&type=template&id=1b548bfe&scoped=true&"
import script from "./PlanBoardButton.vue?vue&type=script&lang=js&"
export * from "./PlanBoardButton.vue?vue&type=script&lang=js&"
import style0 from "./PlanBoardButton.vue?vue&type=style&index=0&id=1b548bfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b548bfe",
  null
  
)

export default component.exports